import acerto from '@acerto/web-sdk';
import { datadogRum } from '@datadog/browser-rum';
import packageJson from '../package.json';

export default function initDataDog(): void {
  if (appSettings.VUE_APP_AMBIENTE !== 'prd') return;

  datadogRum.init({
    applicationId: appSettings.VUE_APP_APPLICATION_ID_DATADOG,
    clientToken: appSettings.VUE_APP_CLIENT_TOKEN_DATADOG,
    site: 'us3.datadoghq.com',
    service: 'meu-acerto-negociacao',
    allowedTracingUrls: [
      (url: string) => url.startsWith('https://app.acerto.com.br/api/'),
      // API de crédito tem host próprio; sem isto o trace do backend não correlaciona com a
      // sessão RUM e um erro na jornada não leva ao span que o causou. Reusa a config que a
      // jornada já lê para o baseURL do axios, em vez de embutir um host aqui: sem valor
      // configurado (feature ainda não habilitada no ambiente), nenhuma URL passa no matcher.
      ...(appSettings.VUE_APP_CREDITO_API_URL
        ? [(url: string) => url.startsWith(appSettings.VUE_APP_CREDITO_API_URL)]
        : []),
    ],
    env: 'producao',
    version: packageJson.version,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
  });

  datadogRum.setGlobalContextProperty('_acerto_did', acerto.getDeviceId());
  datadogRum.setGlobalContextProperty('_acerto_sid', acerto.getSessionId());
}
